import { combineReducers, configureStore } from '@reduxjs/toolkit'

import authReducer from './auth/reducer'
import currencyReducer from './currency/reducer'
import cabinetsInfoReducer from './cabinetsInfo/reduser'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import themeReducer from './theme/reducer'

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth', 'currency', 'themes'],
}

const rootReducer = combineReducers({
  auth: authReducer,
  currency: currencyReducer,
  themes: themeReducer,
  cabinetsList: cabinetsInfoReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

//todo: fix ignoredActions
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
